var render = function render(){var _vm=this,_c=_vm._self._c;return _c('with-actions',[_c('div',{staticClass:"form-inline",attrs:{"slot":"context-actions"},slot:"context-actions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v(_vm._s(_vm._f("t")('save')))])]),_c('automations-form',{model:{value:(_vm.automation),callback:function ($$v) {_vm.automation=$$v},expression:"automation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }